module.exports = __webpack_public_path__ + "img/fotos_5.2011053f.jpg";